import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=ff78ec4e&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=ff78ec4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff78ec4e",
  null
  
)

export default component.exports